import { motion } from "motion/react";
import { pillarEntries, worldNavigation } from "../content/portfolio";
import { navigate } from "../lib/navigation";
import { usePortfolioStore } from "../state/usePortfolioStore";

export function WorldIndex() {
  const visited = usePortfolioStore((state) => state.visited);

  return (
    <motion.main
      id="main-content"
      className="world-index panel-surface"
      tabIndex={-1}
      initial={{ opacity: 0, clipPath: "inset(0 0 100% 0)" }}
      animate={{ opacity: 1, clipPath: "inset(0 0 0% 0)" }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1] }}
    >
      <div className="panel-heading">
        <div>
          <p className="signal-label">Portfolio map</p>
          <h1>How I think, build, and deliver.</h1>
        </div>
        <button type="button" onClick={() => navigate("/")}>
          Return to world
        </button>
      </div>

      <div className="index-list">
        {worldNavigation.map((entry) => {
          const pillar = pillarEntries.find(
            (candidate) => candidate.id === entry.id,
          );
          const wasVisited = visited.includes(entry.route);
          return (
            <button
              className="index-entry"
              type="button"
              key={entry.id}
              onClick={() => navigate(entry.route)}
            >
              <span className="index-signal" data-entry={entry.id} />
              <span>
                <small>{entry.eyebrow}</small>
                <strong>{pillar?.title ?? entry.label}</strong>
                <em>{wasVisited ? "Resume" : "Explore"}</em>
              </span>
            </button>
          );
        })}
      </div>
    </motion.main>
  );
}
